import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import P1 from "../views/P1.vue"
import Lead from "../views/Lead.vue"
import Direct from "../views/Direct.vue"
import P2 from "../views/P2.vue"
import P3 from "../views/P3.vue"
import P4 from "../views/P4.vue"
import P5 from "../views/P5.vue"
import P6 from "../views/P6.vue"
import Notices from "../views/Notices.vue"
//import Privacy from "../views/Privacy.vue"  <-- Redirects to db.com privacy page now
import Success from "../views/SuccessLead.vue"
import Confirmation from "../views/SuccessApply.vue"
import store from "../store/index"


Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/1",
    name: "P1",
    component: P1,
    beforeEnter: (to, from, next) => {
      if(store.getters.getLocations.length == 0) {
        return next({
          name: 'Home'
        })
      }
      return next()
    }
  },
  {
    path: "/2",
    name: "P2",
    component: P2,
  },
  {
    path: "/3",
    name: "P3",
    component: P3,
  },
  {
    path: "/4",
    name: "P4",
    component: P4,
  },
  {
    path: "/5",
    name: "P5",
    component: P5,
  },
  {
    path: "/6",
    name: "P6",
    component: P6,
  },
  {
    path: "/lead/:location",
    name: "Lead",
    component: Lead,
  },
  {
    path: "/success",
    name: "Success",
    component: Success,
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: Confirmation,
  },
  {
    path: "/privacy-rights-notice",
    name: "Privacy Rights Notice",
    beforeEnter() {location.href = "https://www.dutchbros.com/privacy-rights-notice"}
  },
  {
    path: "/employment-notices",
    name: "Employment Notices",
    component: Notices,
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("../views/Help.vue"),
  },
  {
    path: "/:location",
    component: Direct,
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
